module.exports = __webpack_public_path__ + "static/media/img4.49c38df3.jpg";